var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "copy",
    d: "M10,0V1.25a.723.723,0,0,1-.219.531A.723.723,0,0,1,9.25,2H.75a.723.723,0,0,1-.531-.219A.723.723,0,0,1,0,1.25v-11.5a.723.723,0,0,1,.219-.531A.723.723,0,0,1,.75-11H3v9.25A1.684,1.684,0,0,0,3.516-.516,1.684,1.684,0,0,0,4.75,0Zm0-10.75a.723.723,0,0,0,.219.531A.723.723,0,0,0,10.75-10H14v8.25a.723.723,0,0,1-.219.531A.723.723,0,0,1,13.25-1H4.75a.723.723,0,0,1-.531-.219A.723.723,0,0,1,4-1.75v-11.5a.723.723,0,0,1,.219-.531A.723.723,0,0,1,4.75-14H10Zm3.781-.969a.723.723,0,0,1,.219.531V-11H11v-3h.188a.723.723,0,0,1,.531.219Z",
    transform: "translate(0 14)",
    fill: "#5d6373"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.619af56650c1126487130d63390553f7.svg";
export { ForwardRef as ReactComponent };